//----------------------------------------------------
//     general mouse/keyboard accessibility fix
//----------------------------------------------------

$(document).on('mousedown touchdown', 'a, button, input, select, input[type=radio] + label, input[type=checkbox] + label, label, .button, textarea', function(e) {
    $(this).addClass('no-focus');
}).on('blur touchend', function(e) {
    $(this).removeClass('no-focus');
});


$(document).ready(function() {
    //----------------------------------------------------
    //      set "archived" posts
    //----------------------------------------------------

    $('#best-before-content .post').each(function(i) {
        var postDate = moment($(this).find('.post-info time').attr('datetime'), 'YYYY-MM-DD-HH:mm:ss'),
            rightNow = moment(moment.utc(), 'YYYY-MM-DD-HH:mm:ss');

        //console.log(postDate, rightNow);
        //console.log('post' + i, ' ', rightNow.diff(postDate, 'days'));

        if ( rightNow.diff(postDate, 'days') > 29 ) {
            $(this).addClass('archived');
        }
    });

    /*$('.post.archived').on({
        mouseover: function() {
            $(this).removeClass('archived');
        },

        mouseout: function() {
            $(this).addClass('archived');
        }
    });*/
});
